import { render, staticRenderFns } from "./AddNewPaymentRequest.vue?vue&type=template&id=2e4cbc34&scoped=true"
import script from "./AddNewPaymentRequest.vue?vue&type=script&lang=ts"
export * from "./AddNewPaymentRequest.vue?vue&type=script&lang=ts"
import style0 from "./AddNewPaymentRequest.vue?vue&type=style&index=0&id=2e4cbc34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../DATA/projects/nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4cbc34",
  null
  
)

export default component.exports